import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import Select from 'react-select'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import './customDatePickerWidth.css'

const divStyle = {
  float: 'left',
  paddingLeft: '0px',
}

const aStyle = {
  display: 'none',
}

const options = [
  { value: 'Id', label: 'Id Document' },
  { value: 'Qualification', label: 'Qualification Document' },
  { value: 'Other', label: 'Other' },
]

const DocumentForm = props => <Formik initialValues={{ document_type: props.document.document.document_type, cnp: props.document.document.cnp, series: props.document.document.series, number: props.document.document.number, title: props.document.document.title, date: props.document.document.date, link: '' }} enableReinitialize={true} validate={values => {
      const errors = {}
      const sel = document.getElementById('mytype')
      values.document_type = sel.childNodes[1].value
      //const fl = document.getElementById('myfile')
      if (!values.date) {
        errors.date = 'Required'
      } else if (!values.document_type) {
        errors.name = 'Required'
      }
      return errors
    }} onSubmit={(values, { setSubmitting }) => {
      const formData = new FormData()
      const datev = new Date(values.date)
      const ddatev = new Date(datev.getTime() - (datev.getTimezoneOffset() * 60000)).toISOString()
      .replace(/T/, ' ')
      .replace(/\..+/, '')
      if (props.document.document.action === 'Add document'){
        //body = JSON.stringify({id_user: props.document.document.id_user, document_type: values.document_type, cnp: values.cnp, series: values.series, number: values.number, title: values.title, date: values.date, link: values.link})
        formData.append('id_user', props.document.document.id_user)
        formData.append('document_type', values.document_type)
        formData.append('cnp', values.cnp)
        formData.append('series', values.series)
        formData.append('number', values.number)
        formData.append('title', values.title)
        formData.append('date', ddatev)
        formData.append('link', values.link)
      } else {
        //body = JSON.stringify({id_user: props.document.document.id_user, document_type: values.document_type, cnp: values.cnp, series: values.series, number: values.number, title: values.title, date: values.date, link: values.link})
        formData.append('id_user', props.document.document.id_user)
        formData.append('document_type', values.document_type)
        formData.append('cnp', values.cnp)
        formData.append('series', values.series)
        formData.append('number', values.number)
        formData.append('title', values.title)
        formData.append('date', ddatev)
        formData.append('link', values.link)
      }
      let urlf = '/api/v1/documents/'
      let meth = ''
      if (props.document.document.action === 'Add document'){
        meth = 'POST'
        fetch(urlf, {
          method: meth,
          body: formData,
        })
        .then(response => response.json())
        .then(() => {
          document.getElementById('mylink').click()
        })
        .catch((err) => {
          console.error('Error while adding document! ' + err)
        })
        setTimeout(() => {
          setSubmitting(false)
        }, 400)
      } else {
        meth = 'PATCH'
        urlf = urlf + props.document.document.id
        fetch(urlf, {
          method: meth,
          body: formData,
        })
        .then(response => response.json())
        .then(() => {
          document.getElementById('mylink').click()
        })
        .catch((err) => {
          console.error('Error while adding document! ' + err)
        })
        setTimeout(() => {
          setSubmitting(false)
        }, 400)
      }
    }}>{({ isSubmitting, errors, values, setFieldValue}) => <Fragment><a href={'/employee_details/' + props.document.document.id_user} id="mylink" style={aStyle}></a><div className="row col-sm-12 justify-content-top"><h3>{props.document.document.action}</h3></div><br /><Form><div className="row col-sm-12"><div className="col-sm-6" style={divStyle}><div><label htmlFor="document_type">Document type</label><br /><Select id="mytype" name="document_type" options={options} defaultValue={options[props.document.document.index_doc]} onChange={(opt) => {
                                                                                                                props.document.document.document_type = opt.value
                                                                                                                opt.value === 'Id' ? document.getElementById('cnpdiv').style.display = 'block' : document.getElementById('cnpdiv').style.display = 'none'
                                                                                                                }
                                                                                                              }></Select></div><ErrorMessage name="name" component="div"></ErrorMessage><br /><div id="cnpdiv" style={{ display: props.document.document.document_type === 'Id' || props.document.document.document_type === '' ? 'block' : 'none'}}><div><label htmlFor="cnp">CNP</label><br /><Field type="text" name="cnp" className={'form-control' + (errors.cnp ? ' is-invalid' : '')}></Field></div><ErrorMessage name="cnp" component="div"></ErrorMessage><br /></div><div><label htmlFor="series">Series</label><br /><Field type="text" name="series" className={'form-control' + (errors.series ? ' is-invalid' : '')}></Field></div><ErrorMessage name="series" component="div"></ErrorMessage><br /><div><label htmlFor="number">Number</label><br /><Field type="text" name="number" className={'form-control' + (errors.number ? ' is-invalid' : '')}></Field></div><ErrorMessage name="number" component="div"></ErrorMessage><br /></div><div className="col-sm-6" style={divStyle}><div><label htmlFor="title">Title</label><br /><Field type="text" name="title" className={'form-control' + (errors.title ? ' is-invalid' : '')}></Field></div><ErrorMessage name="title" component="div"></ErrorMessage><br /><div><label htmlFor="date">Date of issue</label><br /><div className="customDatePickerWidth"><DatePicker name="date" dateFormat="dd/MM/yyyy" placeholderText="dd/mm/yyyy" utcOffset={0} selected={values.date !== '' ? new Date(values.date) : values.date} className={'form-control' + (errors.date ? ' is-invalid' : '')} onChange={ (val) => { setFieldValue('date', val, false) }} onSelect={ (val) => setFieldValue('date', val, false) }></DatePicker></div></div><ErrorMessage name="date" component="div"></ErrorMessage><br /><div><label htmlFor="pdf">{ props.document.document.link !== '' && <span>Choose another file (pdf)</span>}{ props.document.document.link === '' && <span>Choose file (pdf)</span>}{ props.document.document.link !== '' && <span>                                                             (Existing file: {props.document.document.link})</span>}</label><br /><Field type="file" name="pdf" id="myfile" onChange={ (e) => values.link = e.target.files[0] } className={'form-control' + (errors.date ? ' is-invalid' : '')}></Field></div><ErrorMessage name="pdf" component="div"></ErrorMessage><br /></div><button type="submit" disabled={isSubmitting}>{props.document.document.action}</button><br /><br /></div></Form></Fragment>}</Formik>

DocumentForm.propTypes = {
  document: PropTypes.object,
}

export default DocumentForm
